import { Typography } from '@mui/material';
import { FC, useCallback, useContext } from 'react';

import { ModalContext } from '../../../../app/components/root-modal/RootModal';
import { OkDlg } from '../../../../general/dialogs/ok-dlg';
import { GET_STARTED } from '../../../../paths';

type Props = {
  onClose: () => void;
};

const UserWithEmailExistsDlg: FC<Props> = ({ onClose }: Props) => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { navigate } = useContext(ModalContext);

  const goBack = useCallback(() => {
    void navigate(GET_STARTED, {
      replace: true,
    });
    onClose();
  }, [navigate, onClose]);

  return (
    <OkDlg
      content={
        <>
          <Typography variant="subtitle1" align="center">
            It looks like you already have a Coast account. If you are trying to apply for another one, please make sure
            you use the same phone number.
          </Typography>
        </>
      }
      title="You Already Have a Coast Account"
      okLabel="Go Back"
      onOk={goBack}
      onClose={onClose}
    />
  );
};

export { UserWithEmailExistsDlg };
